import React from 'react';

const ListLaodingMore = (props) => {

    return (
      <div className='list-item__loading mb-3'>
        <div className="list-item__loading--load-more"></div>
      </div>
    );
}


export default ListLaodingMore;